import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaMoon, FaSun } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { navigateToSection } from "../utils/hashSectionNav";
import { useTheme } from "../context/ThemeContext";

export const Navigation = (props) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  const goToSection = (e, sectionId) => {
    e.preventDefault();
    navigateToSection(navigate, location, sectionId);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  const urlRegister = props.data
    ? "https://app." + props.data.nameBankDomain + ".com.br/register"
    : "indefinido";
  const urlLogin = props.data
    ? "https://app." + props.data.nameBankDomain + ".com.br/login"
    : "indefinido";

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">{t("nav.toggleNav")}</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
            <img
              src="/img/logo-cofisa.png"
              alt={props.data ? props.data.nameBank : "COFISA"}
              className="styled-logo"
            />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right ul-limited">
            <li>
              <a
                href="#about"
                className="page-scroll"
                onClick={(e) => goToSection(e, "about")}
              >
                {t("nav.about")}
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                {t("nav.forBusiness")}
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="page-scroll"
                onClick={(e) => goToSection(e, "services")}
              >
                {t("nav.forYou")}
              </a>
            </li>
            <li className="nav-cta-wrap">
              <div className="nav-cta">
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--ghost"
                  onClick={() => openInNewTab(urlLogin)}
                >
                  {t("nav.accessAccount")}
                </button>
                <button
                  type="button"
                  className="btn nav-cta-btn nav-cta-btn--primary"
                  onClick={() => openInNewTab(urlRegister)}
                >
                  {t("nav.openAccount")}
                </button>
              </div>
            </li>
            <li className="nav-theme-toggle-wrap">
              <button
                type="button"
                className="nav-theme-toggle"
                onClick={toggleTheme}
                aria-label={
                  theme === "dark" ? t("theme.lightAria") : t("theme.darkAria")
                }
                title={theme === "dark" ? t("theme.lightTitle") : t("theme.darkTitle")}
              >
                {theme === "dark" ? <FaSun /> : <FaMoon />}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
